__webpack_require__.p = "/wp-content/themes/ppr-child-theme/assets/";